import _extends from "@babel/runtime/helpers/extends";
import "core-js/modules/es.string.link.js";
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button';
import useCallbackRef from 'hooks/useCallbackRef';
import ButtonPanel from './ButtonPanel';
import { useAutoCompletion } from '../AutoCompleteWrapper';
function DirectDownloadLink(_ref) {
  var asset = _ref.asset,
    link = _ref.link,
    autoCompleteEnabled = _ref.autoCompleteEnabled,
    onLoad = _ref.onLoad,
    onComplete = _ref.onComplete;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var onLoadRef = useCallbackRef(onLoad);
  useEffect(function () {
    if (asset) {
      onLoadRef.current();
    }
  }, [asset, onLoadRef]);
  var _useAutoCompletion = useAutoCompletion({
      autoCompleteEnabled: autoCompleteEnabled,
      userContentStatus: asset.userContentStatus,
      onComplete: onComplete
    }),
    markAsCompleted = _useAutoCompletion.markAsCompleted;
  var buttonProps = {
    as: 'a',
    href: link,
    onClick: markAsCompleted
  };
  return /*#__PURE__*/React.createElement(ButtonPanel, {
    asset: asset,
    imageButtonProps: buttonProps
  }, /*#__PURE__*/React.createElement(Button, _extends({}, buttonProps, {
    variant: "primary",
    icon: "download"
  }), t('actions_download')));
}
export default DirectDownloadLink;